import { render, staticRenderFns } from "./ControlPlantProtection.vue?vue&type=template&id=d30d3228&scoped=true&"
import script from "./ControlPlantProtection.vue?vue&type=script&lang=ts&"
export * from "./ControlPlantProtection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d30d3228",
  null
  
)

export default component.exports